import { SET_SELECTED_CALENDAR_MONTH } from 'actions';

export function setSelectedCalendarMonth(selectedCalendarMonth: string | null) {
  return { selectedCalendarMonth, type: SET_SELECTED_CALENDAR_MONTH };
}
